import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-476a2446"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-deletion" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"account-deletion__intro\" data-v-476a2446><p class=\"eyebrow\" data-v-476a2446>MoTobi · SUHWAN LIM</p><h1 data-v-476a2446>Delete your MoTobi account</h1><p data-v-476a2446> This is the official account deletion page for <strong data-v-476a2446>MoTobi</strong>, provided by the developer <strong data-v-476a2446>SUHWAN LIM</strong>. </p></section><section class=\"account-deletion__section\" aria-labelledby=\"deletion-details\" data-v-476a2446><h2 id=\"deletion-details\" data-v-476a2446>What happens when your account is deleted</h2><ul data-v-476a2446><li data-v-476a2446>Your MoTobi account is permanently deleted.</li><li data-v-476a2446> Personal information and content associated with the account, including your profile, chat metadata, and matching preferences, are deleted. </li><li data-v-476a2446> Personal information remaining in backup systems is deleted within 90 days and is used only for disaster recovery during that period. </li><li data-v-476a2446> We may retain the minimum information required by applicable law, or needed for fraud prevention or dispute resolution, only for the required period. </li></ul><p class=\"notice\" data-v-476a2446> Account deletion cannot be undone. Deleting your account does not automatically cancel an active Google Play or App Store subscription. Please cancel any active subscription in the relevant store first. </p></section>", 2)
const _hoisted_4 = {
  class: "account-deletion__section",
  "aria-labelledby": "deletion-request"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "deletion-request" }, "Request account deletion", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " If you registered with an email address and password, enter them below to verify ownership and permanently delete your account. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Account email", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1))
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "success",
  role: "status"
}
const _hoisted_11 = {
  key: 1,
  class: "error",
  role: "alert"
}
const _hoisted_12 = {
  class: "account-deletion__section",
  "aria-labelledby": "social-account"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "social-account" }, "Social sign-in accounts and support", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" If you signed in with Google, Apple, Kakao, or LINE, or cannot use the form above, email "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:motobi.helpdesk@gmail.com?subject=MoTobi%20account%20deletion%20request" }, " motobi.helpdesk@gmail.com "),
  /*#__PURE__*/_createTextVNode(" from the email address associated with your account. Include “MoTobi account deletion request” in the subject. We may ask you to verify account ownership before processing the request. ")
], -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" For more information, read our ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Privacy Policy")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(". ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitDeletionRequest && _ctx.submitDeletionRequest(...args)), ["prevent"]))
      }, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          type: "email",
          id: "email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          autocomplete: "username",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.email]
        ]),
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          type: "password",
          id: "password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          autocomplete: "current-password",
          required: "",
          minlength: "6"
        }, null, 512), [
          [_vModelText, _ctx.password]
        ]),
        _createElementVNode("button", {
          type: "submit",
          disabled: _ctx.isSubmitting
        }, _toDisplayString(_ctx.isSubmitting ? 'Processing...' : 'Permanently delete my account'), 9, _hoisted_9)
      ], 32),
      (_ctx.successMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.successMessage), 1))
        : _createCommentVNode("", true),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_12, [
      _hoisted_13,
      _hoisted_14,
      _createElementVNode("p", null, [
        _hoisted_15,
        _createVNode(_component_router_link, { to: "/privacy-policy" }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }),
        _hoisted_17
      ])
    ])
  ]))
}